import React from 'react';

export const CadastrarContexto = React.createContext(null);